// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  getSearchData,
  getBasket,
  getError,
  getTotal,
  getLoading,
  getDeleteItem,
  getBasketNotifyError,
  getDisableGetPriceButton,
  getBookshopBasket,
} from '../../store/selectors';
import * as basketActions from '../../store/actions';
import BasketPaperInfo from './BasketPaperInfo';
import { setIsCollectionArranged } from '../../../choose-delivery/store/actions';
import { checkoutForTradeCustomer } from
'../../../account/components/AccountTab/components/MyProfile/store/actions';

class BasketPaperInfoContainer extends Component {
  onChangeInput = (value, name) => {
    this.props.setDisableGetPriceButton(Boolean(value.length === 0));
    this.props.changeField(value, name);
    if (this.props.error) {
      this.props.changeErrors(null, 'EAN');
    }
  };

  componentDidMount() {
    this.props.setIsCollectionArranged(false);
    const CartID = localStorage.getItem('CartID');
    if (CartID) {
      this.props.getCart(CartID);
      this.props.getBasketNotifyError(CartID);
    }
  }

  componentWillUnmount() {
    this.props.changeField('', 'EAN');
    this.props.setBasketNotifyError(null);
  }

  render() {
    return <BasketPaperInfo {...this.props} onChangeInput={this.onChangeInput} />;
  }
}

BasketPaperInfoContainer.propTypes = {
  getCart: PropTypes.func,
  changeField: PropTypes.func,
  changeErrors: PropTypes.func,
  error: PropTypes.string,
  setIsCollectionArranged: PropTypes.func,
  checkoutForTradeCustomer: PropTypes.func,
  setBasketNotifyError: PropTypes.func,
  setDisableGetPriceButton: PropTypes.func,
  getBasketNotifyError: PropTypes.func,
};

BasketPaperInfoContainer.defaultProps = {
  getCart: () => { },
  changeField: () => { },
  changeErrors: () => { },
  error: null,
  setIsCollectionArranged: () => { },
  checkoutForTradeCustomer: () => { },
  setBasketNotifyError: () => { },
  getBasketNotifyError: () => { },
  setDisableGetPriceButton: () => { },
};

function mapStateToProps(state) {
  return {
    search: getSearchData(state),
    basket: getBasket(state),
    error: getError(state),
    total: getTotal(state),
    loading: getLoading(state),
    deleteItem: getDeleteItem(state),
    basketNotifyError: getBasketNotifyError(state),
    disableGetPriceButton: getDisableGetPriceButton(state),
    bookshopBasket: getBookshopBasket(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSearch: EAN => dispatch(basketActions.requestBasketSearch(EAN)),
    getCart: data => dispatch(basketActions.requestBasket(data)),
    removeItem: (item, token, customerId) => dispatch(basketActions
      .removeItem(item, token, customerId)),
    setDeleteItem: item => dispatch(basketActions.setDeleteItem(item)),
    changeField: (value, name) => dispatch(basketActions.changeField(value, name)),
    changeErrors: (error, field) => dispatch(basketActions.changeErrors(error, field)),
    setIsCollectionArranged: payload => dispatch(setIsCollectionArranged(payload)),
    checkoutForTradeCustomer: () => dispatch(checkoutForTradeCustomer()),
    getBasketNotifyError: cartId => dispatch(basketActions.getBasketNotifyError(cartId)),
    setBasketNotifyError: error => dispatch(basketActions.setBasketNotifyError(error)),
    setDisableGetPriceButton: payload => dispatch(basketActions.setDisableGetPriceButton(payload))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BasketPaperInfoContainer);
